module.exports = __webpack_public_path__ + "img/methoden_1280.e351731f.png";